module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAPCAIAAACN07NGAAAA10lEQVQoFWP8//8/A4mABaj+7aZ896ajRGi0rt020V+MAaTn6QO8Gqxqd07yF2Z4uzHP/f4zBgaIHgI2HGt2N2mGqIlJAtFMQKyXt7PWCiKIj7Su21lgAFLASGYYXJpkkrQInw1wuZg5Z4BWgcIAK4BII0mBwwDMB+mRVrBmYEAPuiUpJkuQdICZ1rU1IJpc/zAwXJpgkoRhKrotDHHzzuTpAUVBYX1pEhEagOoWJU24ADIIZxiAJIEAZjYwhYHSAVgM7J8LE0xSCDuNgSFm3pkCoOPICQMApGlIo5ALOBcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/tasks.png
// module id = vk/p
// module chunks = 1